import { atom, getDefaultStore } from 'jotai';
import { DisplayPreviewContentView, DisplayPreviewView } from 'common';
import { SharePopupInfo, ShareNetworkType, ShareInfo } from '@src/types/share';
import { ANALYTICS_ACTIONS, ANALYTICS_CATEGORIES, trackAnalyticsEvent } from '@src/utils/analyticsTracking';

const jotaiStore = getDefaultStore();

export const sharePopupAtom = atom<SharePopupInfo | null>(null);
export const sharePromptAtom = atom<ShareInfo | null>(null);
export const displayPreviewAtom = atom<DisplayPreviewView | null>(null);
export const publishingAtom = atom(false);
export const publishErrorAtom = atom<string | null>(null);

export function openSharePopup(target: ShareNetworkType, info: SharePopupInfo): void {
  jotaiStore.set(sharePopupAtom, { ...info, target });
}

export function closeSharePopup(): void {
  jotaiStore.set(sharePopupAtom, null);
  jotaiStore.set(publishErrorAtom, null);
  jotaiStore.set(publishingAtom, false);
}

export function openSharePrompt(info: ShareInfo): void {
  jotaiStore.set(sharePromptAtom, info);
}

export function closeSharePrompt(): void {
  jotaiStore.set(sharePromptAtom, null);
}

export function setDisplayPreview(displayPreview: DisplayPreviewView): void {
  jotaiStore.set(displayPreviewAtom, displayPreview);
}

export function setInsertedDisplayPreviewContent(content: DisplayPreviewContentView): void {
  jotaiStore.set(displayPreviewAtom, (prev) => {
    if (!prev?.content) {
      return prev;
    }
    const contentList = [...prev.content];
    const updatedIndex = contentList.findIndex(
      (c) => !c._id
        && (c[c.type] as any)._id === (content[content.type] as any)._id,
    );
    if (updatedIndex === -1) {
      return prev;
    }
    const newContent = [...contentList];
    newContent[updatedIndex] = content;
    return { ...prev, content: newContent };
  });
}

export function setPublishing(): void {
  trackAnalyticsEvent(ANALYTICS_ACTIONS.publishing, ANALYTICS_CATEGORIES.share);
  jotaiStore.set(publishingAtom, true);
  jotaiStore.set(publishErrorAtom, null);
}

export function setPublishError(error: string | null): void {
  if (error !== null) {
    trackAnalyticsEvent(ANALYTICS_ACTIONS.publishFailed, ANALYTICS_CATEGORIES.share);
  }
  jotaiStore.set(publishErrorAtom, error);
  jotaiStore.set(publishingAtom, false);
}
